import { getCountry } from "@/country";

/**
 * DİL-3 (30 Ağu 2026) — seçilebilir dillerin TEK kaynağı.
 *
 * NEDEN AYRI DOSYA
 * ----------------
 * Bu mantık iki yerde AYRI AYRI yazılmıştı: başlıktaki seçici (`Layout.jsx`)
 * ve Profil > Ayarlar'daki seçici (`Profile.jsx`). CEVIRI-1'de Portekizce ile
 * İspanyolca eklenirken yalnızca başlıktaki güncellendi — Profil'deki TR/EN'e
 * sabit kaldı. Sonuç iki ayrı hata:
 *
 *   1. Endonezyalı kullanıcı Profil'den Endonezce SEÇEMİYORDU.
 *   2. Yurt dışına **TR düğmesi** gösteriliyordu — kod tabanının her yerinde
 *      tekrarlanan "Türkiye dışında TR yok" kuralını delen tek yer burasıydı.
 *
 * Ayrıca `lang !== "tr"` koşulu yüzünden dil Endonezce iken ekranda "EN"
 * seçili görünüyordu.
 *
 * Ders: aynı kural iki yerde yaşarsa er geç ikisi ayrışır. Kural artık burada,
 * iki seçici de buradan okuyor.
 */

/** Ülkenin kendi dili. Çevirisi eklenen her ülke buraya bir satır. */
export const NATIVE_LANG = { tr: "tr", id: "id", br: "pt-br", es: "es" };

/** Seçicide görünen kısa etiket. */
export const DIL_ETIKETLERI = { tr: "TR", en: "EN", id: "ID", "pt-br": "PT", es: "ES" };

/**
 * Bu cihazda seçilebilecek diller.
 *
 * Sıra: ülkenin kendi dili → İngilizce → (varsa) aktif dil.
 *
 * TÜRKÇE YALNIZCA TÜRKİYE'DE. `NATIVE_LANG[c]` Türkiye dışında hiçbir zaman
 * "tr" vermiyor; liste de "tr"yi başka bir yoldan eklemiyor. Tek istisna:
 * aktif dil zaten "tr" ise seçici onu göstermek zorunda, yoksa kullanıcı
 * seçili dilini ekranda göremez.
 */
export function secilebilirDiller(aktifDil) {
  let c = "tr";
  try {
    c = getCountry();
  } catch {
    /* ülke okunamıyorsa Türkiye varsayılanı — TUR-8 ile aynı yön */
  }
  const diller = [];
  if (NATIVE_LANG[c]) diller.push(NATIVE_LANG[c]);
  if (!diller.includes("en")) diller.push("en");
  if (aktifDil && !diller.includes(aktifDil)) diller.push(aktifDil);
  return diller;
}
